import { apiClient } from './apiClient';
import { API_CONFIG, API_ENDPOINTS } from '@/constants/api';
import type { LocationData } from '@/lib/trackingStream';

export type { LocationData, TrackingStreamPayload } from '@/lib/trackingStream';
export { parseTrackingStreamPayload } from '@/lib/trackingStream';

export const updateDoctorLocation = async (
  appointmentId: string,
  location: LocationData
) => {
  return apiClient.post(API_ENDPOINTS.TRACKING.LOCATION(appointmentId), location);
};

export const endDoctorTracking = async (appointmentId: string) => {
  return apiClient.post(API_ENDPOINTS.TRACKING.END(appointmentId));
};

/** URL do SSE de localização do médico em deslocamento. */
export function getTrackingStreamUrl(appointmentId: string): string {
  return `${API_CONFIG.BASE_URL}${API_ENDPOINTS.TRACKING.STREAM(appointmentId)}`;
}
